export default "__VITE_ASSET__COPsW$f3__"